import commonAPI from './common'
import coldchainAPI from './coldchain'
import normalOrderAPI from './normalOrder'
import fuelAndFeeAPI from './fuelAndFee'
import carrierOrderAPI from './carrierOrder'

let secondCross = '' // 本地调试如有跨域问题则赋值，若上线则把cross置空，并改http.js里的域名 /secondApi
const API = {
  ...commonAPI,
  ...coldchainAPI,
  ...normalOrderAPI,
  ...fuelAndFeeAPI,
  ...carrierOrderAPI
}

if (process.env.NODE_ENV === 'development') {
  Object.values(API).forEach(api => {
    api.url = '/api' + api.url
  })
}

export default API



// WEBPACK FOOTER //
// ./src/api/api.js